import type {TransactionalMessageBanner as TransactionalMessageBannerType} from '@github-ui/code-view-types'

import {TransactionalMessageBanner, type TransactionalMessageBannerDisplayStyle} from './TransactionalMessageBanner'

export interface TransactionalMessageBannersProps {
  banners: TransactionalMessageBannerType[]
  displayStyle: TransactionalMessageBannerDisplayStyle
}

// The index distinguishes banners if two entries share an analytics category.
function getBannerKey(banner: TransactionalMessageBannerType, index: number): string {
  return `${banner.analytics.category}-${index}`
}

export function TransactionalMessageBanners({banners, displayStyle}: TransactionalMessageBannersProps) {
  if (banners.length === 0) {
    return null
  }

  return (
    <>
      {banners.map((banner, index) => (
        <TransactionalMessageBanner key={getBannerKey(banner, index)} banner={banner} displayStyle={displayStyle} />
      ))}
    </>
  )
}
